import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-grievances-icc', templateUrl: './grievances-icc.component.html', styleUrls: ['./grievances-icc.component.scss'] })
export class GrievancesIccComponent implements OnInit { constructor() { } ngOnInit(): void { } }
